import moment from 'moment'
// import { useI18n } from 'vue-i18n'
import { getScaledUnit, scaleNumber } from '@/helpers/number_conversion'

/**
 * Helper to filter multiselect options, fully consisting of groups.
 * Filtering takes into account the grouplabel
 *
 * @function
 *
 * @param {Array<Object>} options
 * @param {string} filter
 *
 * @return {Array<Object>} the filterd options
 */
export const filterGroupedMultiSelectOptions = (options, filter) => {
  const filteredOptions = []
  const includesFilter = (val, filter) => {
    return val.toLowerCase().includes(filter.toLowerCase())
  }

  for (const group of options) {
    if (includesFilter(group.label, filter)) {
      filteredOptions.push(group)
    } else {
      const filteredGroupOptions = []

      for (const option of group.options) {
        if (includesFilter(option.label, filter)) {
          filteredGroupOptions.push(option)
        }
      }

      if (filteredGroupOptions.length) {
        filteredOptions.push({
          label: group.label,
          options: filteredGroupOptions
        })
      }
    }
  }

  return filteredOptions
}

/**
 * Takes a datetime and outputs a formatted string,
 * e.g. `06.11.2023 15:16:02  (lokal)`
 *
 *
 * @function
 *
 * @param {Moment|String|Number} datetime (unix timestamp has to be in ms)
 * @param {object} opts
 * @param {string} opts.locale is the locale to be used
 *
 * @return {string}
 */
export function formatTimestampToLocal(datetime, { locale = 'en', withTimeZone = true, timeFormat = 'LTS' } = {}) {
  // const { t } = useI18n()
  const m = moment(datetime)

  m.local()
  m.locale(locale)

  if (withTimeZone) return `${m.format('L')} ${m.format(timeFormat)} (${m.format('Z')})`

  return `${m.format('L')} ${m.format(timeFormat)}`
}

/**
 * Takes a Sensor's value,
 * auto-determines the desired unit,
 * scales accordingly,
 * and outputs a formatted string with unit,
 * e.g. `183.323 kWh`
 *
 * @function
 *
 * @param {Number} val
 * @param {Object} opts
 * @param {string} opts.unit (optional)
 * @param {integer} opts.roundPrecision
 *
 * @return {string}
 */
export function formatValToScaledWithUnit(val, { locale = null, unit, roundPrecision = 3 }) {
  const scaledUnit = getScaledUnit(unit)

  return `${scaleNumber(val, { locale, scale: scaledUnit.scale, roundPrecision })} ${scaledUnit.unit}`
}

export const buildEmsInfosJsonFields = (t) => ({
  [t('api.technician.index.ems_name')]: 'emsName',
  [t('api.technician.index.serialno')]: 'serialno',
  [t('api.technician.index.configuration.non_empty_topology')]: 'nonEmptyTopology',
  [t('api.technician.index.configuration.system_configuration_status')]: 'systemConfigurationStatus',
  [t('api.technician.index.installation.ems_id')]: 'emsId',
  [t('api.technician.index.installation.hw_version')]: 'hwType',
  [t('api.technician.index.installation.hw_serial_number')]: 'hwSerialNumber',
  // [t('api.technician.index.installation.sw_version_initial')]: 'versionOnProd',
  // [t('api.technician.index.installation.license_type')]: 'licenseType',
  [t('api.technician.index.installation.mac_address')]: 'macAddress',
  [t('api.technician.index.installation.sw_version')]: 'swVersion',
  [t('api.technician.index.installation.production_date')]: 'provisionDate',
  [t('api.technician.index.installation.activated_at')]: 'activatedAt',
  [t('api.technician.index.installation.put_into_service_at')]: 'putIntoServiceAt'
})
